import { useEffect } from 'react';

/** Tell the parent whether the section is edited; clean again when the section goes away. */
export function useReportDirty(
  dirty: boolean,
  onDirtyChange: ((dirty: boolean) => void) | undefined,
) {
  useEffect(() => {
    onDirtyChange?.(dirty);
    return () => onDirtyChange?.(false);
  }, [dirty, onDirtyChange]);
}
